import * as React from 'react';

import { renderEmpty } from '../../common/Render';

import { IReportSettings, PM } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import JobTable from './JobTable';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

interface IJobsById {
    nodeId?: PM.IJob[];
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        jobs: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderData(nodes: PM.ISystem[], jobs: IJobsById, settings: ISettings, reportSettings: IReportSettings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                return (
                    <div key={nodeKey}>
                        <JobTable title={node.name} jobs={jobs[node.id]} settings={settings} />
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    render() {
        let { systems, jobs } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter((system: PM.ISystem) => {
            if (!system.pmInformation) {
                return false;
            }

            if (!settings.displaySystemsWithoutJobs) {
                const systemJobs = jobs[system.id] || [];
                return systemJobs.length > 0;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, jobs, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listJobs/Widget.tsx